// Auto-generated team hat catalog. Logos from official league CDNs (MLB/NBA/ESPN/NHL).
import orlandoMagicLogo from "@/assets/team-logos/orlando-magic.webp";

export interface Hat {
  id: string;
  title: string;
  price: string;
  image: string;
  bg: string;
  description: string;
  style: string;
  retailer: string;
}

export interface TeamEntry {
  team: string;
  league: string;
  logo: string;
  hats: Hat[];
}

export const teamHats: Record<string, TeamEntry[]> = {
  "MLB": [
    {
      "team": "Arizona Diamondbacks",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/109.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Arizona Diamondbacks 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Arizona Diamondbacks logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Atlanta Braves",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/144.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Atlanta Braves 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Atlanta Braves logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Baltimore Orioles",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/110.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Baltimore Orioles 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Baltimore Orioles logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Boston Red Sox",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/111.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Boston Red Sox 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Boston Red Sox logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Chicago Cubs",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/112.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Chicago Cubs 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Chicago Cubs logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Chicago White Sox",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/145.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Chicago White Sox 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Chicago White Sox logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Cincinnati Reds",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/113.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Cincinnati Reds 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Cincinnati Reds logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Cleveland Guardians",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/114.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Cleveland Guardians 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Cleveland Guardians logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Colorado Rockies",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/115.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Colorado Rockies 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Colorado Rockies logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Detroit Tigers",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/116.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Detroit Tigers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Detroit Tigers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Houston Astros",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/117.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Houston Astros 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Houston Astros logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Kansas City Royals",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/118.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Kansas City Royals 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Kansas City Royals logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Los Angeles Angels",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/108.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Los Angeles Angels 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Los Angeles Angels logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Los Angeles Dodgers",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/119.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Los Angeles Dodgers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Los Angeles Dodgers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Miami Marlins",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/146.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Miami Marlins 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Miami Marlins logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Milwaukee Brewers",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/158.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Milwaukee Brewers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Milwaukee Brewers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Minnesota Twins",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/142.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Minnesota Twins 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Minnesota Twins logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "New York Mets",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/121.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "New York Mets 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered New York Mets logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "New York Yankees",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/147.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "New York Yankees 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered New York Yankees logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Oakland Athletics",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/133.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Oakland Athletics 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Oakland Athletics logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Philadelphia Phillies",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/143.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Philadelphia Phillies 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Philadelphia Phillies logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Pittsburgh Pirates",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/134.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Pittsburgh Pirates 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Pittsburgh Pirates logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "San Diego Padres",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/135.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "San Diego Padres 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered San Diego Padres logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "San Francisco Giants",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/137.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "San Francisco Giants 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered San Francisco Giants logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Seattle Mariners",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/136.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Seattle Mariners 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Seattle Mariners logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "St. Louis Cardinals",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/138.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "St. Louis Cardinals 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered St. Louis Cardinals logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Tampa Bay Rays",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/139.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Tampa Bay Rays 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Tampa Bay Rays logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Texas Rangers",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/140.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Texas Rangers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Texas Rangers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Toronto Blue Jays",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/141.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Toronto Blue Jays 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Toronto Blue Jays logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Washington Nationals",
      "league": "MLB",
      "logo": "https://www.mlbstatic.com/team-logos/120.svg",
      "hats": [
        {
          "id": "team-color-fitted",
          "title": "Washington Nationals 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Washington Nationals logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        }]
    }
  ],
  "NBA": [
    {
      "team": "Atlanta Hawks",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612737/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Atlanta Hawks 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Atlanta Hawks logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Atlanta Hawks 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Atlanta Hawks logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Atlanta Hawks 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Atlanta Hawks logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Atlanta Hawks Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Atlanta Hawks mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Atlanta Hawks Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Atlanta Hawks front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Atlanta Hawks Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Atlanta Hawks logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Boston Celtics",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612738/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Boston Celtics 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Boston Celtics logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Boston Celtics 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Boston Celtics logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Boston Celtics 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Boston Celtics logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Boston Celtics Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Boston Celtics mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Boston Celtics Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Boston Celtics front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Boston Celtics Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Boston Celtics logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Brooklyn Nets",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612751/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Brooklyn Nets 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Brooklyn Nets logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Brooklyn Nets 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Brooklyn Nets logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Brooklyn Nets 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Brooklyn Nets logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Brooklyn Nets Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Brooklyn Nets mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Brooklyn Nets Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Brooklyn Nets front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Brooklyn Nets Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Brooklyn Nets logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Charlotte Hornets",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612766/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Charlotte Hornets 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Charlotte Hornets logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Charlotte Hornets 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Charlotte Hornets logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Charlotte Hornets 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Charlotte Hornets logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Charlotte Hornets Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Charlotte Hornets mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Charlotte Hornets Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Charlotte Hornets front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Charlotte Hornets Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Charlotte Hornets logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Chicago Bulls",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612741/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Chicago Bulls 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Chicago Bulls logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Chicago Bulls 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Chicago Bulls logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Chicago Bulls 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Chicago Bulls logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Chicago Bulls Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Chicago Bulls mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Chicago Bulls Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Chicago Bulls front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Chicago Bulls Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Chicago Bulls logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Cleveland Cavaliers",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612739/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Cleveland Cavaliers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Cleveland Cavaliers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Cleveland Cavaliers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Cleveland Cavaliers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Cleveland Cavaliers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Cleveland Cavaliers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Cleveland Cavaliers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Cleveland Cavaliers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Cleveland Cavaliers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Cleveland Cavaliers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Cleveland Cavaliers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Cleveland Cavaliers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Dallas Mavericks",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612742/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Dallas Mavericks 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Dallas Mavericks logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Dallas Mavericks 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Dallas Mavericks logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Dallas Mavericks 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Dallas Mavericks logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Dallas Mavericks Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Dallas Mavericks mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Dallas Mavericks Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Dallas Mavericks front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Dallas Mavericks Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Dallas Mavericks logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Denver Nuggets",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612743/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Denver Nuggets 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Denver Nuggets logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Denver Nuggets 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Denver Nuggets logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Denver Nuggets 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Denver Nuggets logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Denver Nuggets Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Denver Nuggets mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Denver Nuggets Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Denver Nuggets front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Denver Nuggets Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Denver Nuggets logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Detroit Pistons",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612765/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Detroit Pistons 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Detroit Pistons logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Detroit Pistons 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Detroit Pistons logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Detroit Pistons 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Detroit Pistons logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Detroit Pistons Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Detroit Pistons mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Detroit Pistons Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Detroit Pistons front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Detroit Pistons Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Detroit Pistons logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Golden State Warriors",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612744/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Golden State Warriors 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Golden State Warriors logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Golden State Warriors 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Golden State Warriors logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Golden State Warriors 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Golden State Warriors logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Golden State Warriors Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Golden State Warriors mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Golden State Warriors Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Golden State Warriors front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Golden State Warriors Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Golden State Warriors logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Houston Rockets",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612745/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Houston Rockets 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Houston Rockets logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Houston Rockets 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Houston Rockets logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Houston Rockets 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Houston Rockets logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Houston Rockets Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Houston Rockets mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Houston Rockets Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Houston Rockets front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Houston Rockets Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Houston Rockets logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Indiana Pacers",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612754/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Indiana Pacers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Indiana Pacers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Indiana Pacers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Indiana Pacers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Indiana Pacers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Indiana Pacers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Indiana Pacers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Indiana Pacers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Indiana Pacers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Indiana Pacers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Indiana Pacers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Indiana Pacers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Los Angeles Clippers",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612746/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Los Angeles Clippers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Los Angeles Clippers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Los Angeles Clippers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Los Angeles Clippers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Los Angeles Clippers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Los Angeles Clippers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Los Angeles Clippers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Los Angeles Clippers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Los Angeles Clippers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Los Angeles Clippers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Los Angeles Clippers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Los Angeles Clippers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Los Angeles Lakers",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612747/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Los Angeles Lakers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Los Angeles Lakers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Los Angeles Lakers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Los Angeles Lakers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Los Angeles Lakers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Los Angeles Lakers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Los Angeles Lakers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Los Angeles Lakers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Los Angeles Lakers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Los Angeles Lakers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Los Angeles Lakers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Los Angeles Lakers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Memphis Grizzlies",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612763/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Memphis Grizzlies 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Memphis Grizzlies logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Memphis Grizzlies 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Memphis Grizzlies logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Memphis Grizzlies 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Memphis Grizzlies logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Memphis Grizzlies Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Memphis Grizzlies mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Memphis Grizzlies Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Memphis Grizzlies front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Memphis Grizzlies Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Memphis Grizzlies logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Miami Heat",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612748/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Miami Heat 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Miami Heat logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Miami Heat 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Miami Heat logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Miami Heat 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Miami Heat logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Miami Heat Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Miami Heat mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Miami Heat Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Miami Heat front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Miami Heat Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Miami Heat logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Milwaukee Bucks",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612749/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Milwaukee Bucks 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Milwaukee Bucks logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Milwaukee Bucks 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Milwaukee Bucks logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Milwaukee Bucks 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Milwaukee Bucks logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Milwaukee Bucks Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Milwaukee Bucks mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Milwaukee Bucks Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Milwaukee Bucks front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Milwaukee Bucks Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Milwaukee Bucks logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Minnesota Timberwolves",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612750/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Minnesota Timberwolves 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Minnesota Timberwolves logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Minnesota Timberwolves 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Minnesota Timberwolves logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Minnesota Timberwolves 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Minnesota Timberwolves logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Minnesota Timberwolves Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Minnesota Timberwolves mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Minnesota Timberwolves Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Minnesota Timberwolves front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Minnesota Timberwolves Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Minnesota Timberwolves logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "New Orleans Pelicans",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612740/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "New Orleans Pelicans 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered New Orleans Pelicans logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "New Orleans Pelicans 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered New Orleans Pelicans logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "New Orleans Pelicans 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the New Orleans Pelicans logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "New Orleans Pelicans Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered New Orleans Pelicans mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "New Orleans Pelicans Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered New Orleans Pelicans front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "New Orleans Pelicans Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered New Orleans Pelicans logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "New York Knicks",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612752/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "New York Knicks 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered New York Knicks logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "New York Knicks 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered New York Knicks logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "New York Knicks 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the New York Knicks logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "New York Knicks Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered New York Knicks mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "New York Knicks Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered New York Knicks front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "New York Knicks Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered New York Knicks logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Oklahoma City Thunder",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612760/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Oklahoma City Thunder 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Oklahoma City Thunder logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Oklahoma City Thunder 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Oklahoma City Thunder logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Oklahoma City Thunder 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Oklahoma City Thunder logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Oklahoma City Thunder Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Oklahoma City Thunder mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Oklahoma City Thunder Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Oklahoma City Thunder front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Oklahoma City Thunder Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Oklahoma City Thunder logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Orlando Magic",
      "league": "NBA",
      "logo": orlandoMagicLogo,
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Orlando Magic 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Orlando Magic logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Orlando Magic 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Orlando Magic logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Orlando Magic 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Orlando Magic logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Orlando Magic Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Orlando Magic mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Orlando Magic Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Orlando Magic front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Orlando Magic Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Orlando Magic logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Philadelphia 76ers",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612755/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Philadelphia 76ers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Philadelphia 76ers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Philadelphia 76ers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Philadelphia 76ers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Philadelphia 76ers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Philadelphia 76ers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Philadelphia 76ers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Philadelphia 76ers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Philadelphia 76ers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Philadelphia 76ers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Philadelphia 76ers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Philadelphia 76ers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Phoenix Suns",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612756/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Phoenix Suns 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Phoenix Suns logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Phoenix Suns 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Phoenix Suns logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Phoenix Suns 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Phoenix Suns logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Phoenix Suns Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Phoenix Suns mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Phoenix Suns Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Phoenix Suns front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Phoenix Suns Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Phoenix Suns logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Portland Trail Blazers",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612757/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Portland Trail Blazers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Portland Trail Blazers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Portland Trail Blazers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Portland Trail Blazers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Portland Trail Blazers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Portland Trail Blazers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Portland Trail Blazers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Portland Trail Blazers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Portland Trail Blazers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Portland Trail Blazers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Portland Trail Blazers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Portland Trail Blazers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Sacramento Kings",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612758/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Sacramento Kings 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Sacramento Kings logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Sacramento Kings 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Sacramento Kings logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Sacramento Kings 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Sacramento Kings logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Sacramento Kings Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Sacramento Kings mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Sacramento Kings Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Sacramento Kings front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Sacramento Kings Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Sacramento Kings logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "San Antonio Spurs",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612759/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "San Antonio Spurs 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered San Antonio Spurs logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "San Antonio Spurs 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered San Antonio Spurs logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "San Antonio Spurs 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the San Antonio Spurs logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "San Antonio Spurs Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered San Antonio Spurs mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "San Antonio Spurs Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered San Antonio Spurs front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "San Antonio Spurs Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered San Antonio Spurs logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Toronto Raptors",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612761/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Toronto Raptors 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Toronto Raptors logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Toronto Raptors 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Toronto Raptors logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Toronto Raptors 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Toronto Raptors logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Toronto Raptors Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Toronto Raptors mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Toronto Raptors Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Toronto Raptors front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Toronto Raptors Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Toronto Raptors logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Utah Jazz",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612762/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Utah Jazz 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Utah Jazz logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Utah Jazz 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Utah Jazz logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Utah Jazz 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Utah Jazz logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Utah Jazz Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Utah Jazz mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Utah Jazz Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Utah Jazz front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Utah Jazz Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Utah Jazz logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Washington Wizards",
      "league": "NBA",
      "logo": "https://cdn.nba.com/logos/nba/1610612764/primary/L/logo.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Washington Wizards 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Washington Wizards logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Washington Wizards 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Washington Wizards logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Washington Wizards 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Washington Wizards logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Washington Wizards Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Washington Wizards mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Washington Wizards Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Washington Wizards front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Washington Wizards Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Washington Wizards logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    }
  ],
  "NFL": [
    {
      "team": "Arizona Cardinals",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/ari.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Arizona Cardinals 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Arizona Cardinals logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Arizona Cardinals 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Arizona Cardinals logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Arizona Cardinals 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Arizona Cardinals logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Arizona Cardinals Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Arizona Cardinals mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Arizona Cardinals Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Arizona Cardinals front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Arizona Cardinals Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Arizona Cardinals logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Atlanta Falcons",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/atl.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Atlanta Falcons 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Atlanta Falcons logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Atlanta Falcons 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Atlanta Falcons logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Atlanta Falcons 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Atlanta Falcons logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Atlanta Falcons Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Atlanta Falcons mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Atlanta Falcons Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Atlanta Falcons front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Atlanta Falcons Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Atlanta Falcons logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Baltimore Ravens",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/bal.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Baltimore Ravens 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Baltimore Ravens logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Baltimore Ravens 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Baltimore Ravens logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Baltimore Ravens 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Baltimore Ravens logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Baltimore Ravens Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Baltimore Ravens mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Baltimore Ravens Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Baltimore Ravens front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Baltimore Ravens Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Baltimore Ravens logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Buffalo Bills",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/buf.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Buffalo Bills 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Buffalo Bills logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Buffalo Bills 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Buffalo Bills logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Buffalo Bills 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Buffalo Bills logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Buffalo Bills Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Buffalo Bills mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Buffalo Bills Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Buffalo Bills front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Buffalo Bills Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Buffalo Bills logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Carolina Panthers",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/car.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Carolina Panthers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Carolina Panthers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Carolina Panthers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Carolina Panthers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Carolina Panthers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Carolina Panthers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Carolina Panthers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Carolina Panthers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Carolina Panthers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Carolina Panthers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Carolina Panthers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Carolina Panthers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Chicago Bears",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/chi.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Chicago Bears 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Chicago Bears logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Chicago Bears 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Chicago Bears logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Chicago Bears 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Chicago Bears logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Chicago Bears Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Chicago Bears mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Chicago Bears Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Chicago Bears front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Chicago Bears Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Chicago Bears logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Cincinnati Bengals",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/cin.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Cincinnati Bengals 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Cincinnati Bengals logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Cincinnati Bengals 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Cincinnati Bengals logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Cincinnati Bengals 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Cincinnati Bengals logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Cincinnati Bengals Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Cincinnati Bengals mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Cincinnati Bengals Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Cincinnati Bengals front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Cincinnati Bengals Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Cincinnati Bengals logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Cleveland Browns",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/cle.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Cleveland Browns 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Cleveland Browns logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Cleveland Browns 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Cleveland Browns logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Cleveland Browns 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Cleveland Browns logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Cleveland Browns Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Cleveland Browns mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Cleveland Browns Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Cleveland Browns front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Cleveland Browns Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Cleveland Browns logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Dallas Cowboys",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/dal.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Dallas Cowboys 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Dallas Cowboys logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Dallas Cowboys 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Dallas Cowboys logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Dallas Cowboys 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Dallas Cowboys logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Dallas Cowboys Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Dallas Cowboys mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Dallas Cowboys Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Dallas Cowboys front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Dallas Cowboys Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Dallas Cowboys logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Denver Broncos",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/den.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Denver Broncos 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Denver Broncos logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Denver Broncos 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Denver Broncos logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Denver Broncos 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Denver Broncos logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Denver Broncos Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Denver Broncos mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Denver Broncos Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Denver Broncos front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Denver Broncos Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Denver Broncos logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Detroit Lions",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/det.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Detroit Lions 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Detroit Lions logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Detroit Lions 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Detroit Lions logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Detroit Lions 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Detroit Lions logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Detroit Lions Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Detroit Lions mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Detroit Lions Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Detroit Lions front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Detroit Lions Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Detroit Lions logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Green Bay Packers",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/gb.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Green Bay Packers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Green Bay Packers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Green Bay Packers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Green Bay Packers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Green Bay Packers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Green Bay Packers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Green Bay Packers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Green Bay Packers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Green Bay Packers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Green Bay Packers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Green Bay Packers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Green Bay Packers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Houston Texans",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/hou.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Houston Texans 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Houston Texans logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Houston Texans 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Houston Texans logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Houston Texans 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Houston Texans logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Houston Texans Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Houston Texans mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Houston Texans Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Houston Texans front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Houston Texans Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Houston Texans logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Indianapolis Colts",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/ind.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Indianapolis Colts 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Indianapolis Colts logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Indianapolis Colts 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Indianapolis Colts logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Indianapolis Colts 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Indianapolis Colts logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Indianapolis Colts Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Indianapolis Colts mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Indianapolis Colts Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Indianapolis Colts front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Indianapolis Colts Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Indianapolis Colts logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Jacksonville Jaguars",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/jax.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Jacksonville Jaguars 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Jacksonville Jaguars logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Jacksonville Jaguars 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Jacksonville Jaguars logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Jacksonville Jaguars 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Jacksonville Jaguars logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Jacksonville Jaguars Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Jacksonville Jaguars mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Jacksonville Jaguars Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Jacksonville Jaguars front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Jacksonville Jaguars Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Jacksonville Jaguars logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Kansas City Chiefs",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/kc.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Kansas City Chiefs 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Kansas City Chiefs logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Kansas City Chiefs 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Kansas City Chiefs logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Kansas City Chiefs 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Kansas City Chiefs logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Kansas City Chiefs Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Kansas City Chiefs mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Kansas City Chiefs Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Kansas City Chiefs front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Kansas City Chiefs Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Kansas City Chiefs logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Las Vegas Raiders",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/lv.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Las Vegas Raiders 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Las Vegas Raiders logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Las Vegas Raiders 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Las Vegas Raiders logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Las Vegas Raiders 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Las Vegas Raiders logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Las Vegas Raiders Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Las Vegas Raiders mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Las Vegas Raiders Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Las Vegas Raiders front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Las Vegas Raiders Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Las Vegas Raiders logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Los Angeles Chargers",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/lac.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Los Angeles Chargers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Los Angeles Chargers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Los Angeles Chargers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Los Angeles Chargers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Los Angeles Chargers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Los Angeles Chargers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Los Angeles Chargers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Los Angeles Chargers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Los Angeles Chargers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Los Angeles Chargers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Los Angeles Chargers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Los Angeles Chargers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Los Angeles Rams",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/lar.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Los Angeles Rams 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Los Angeles Rams logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Los Angeles Rams 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Los Angeles Rams logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Los Angeles Rams 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Los Angeles Rams logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Los Angeles Rams Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Los Angeles Rams mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Los Angeles Rams Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Los Angeles Rams front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Los Angeles Rams Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Los Angeles Rams logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Miami Dolphins",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/mia.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Miami Dolphins 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Miami Dolphins logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Miami Dolphins 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Miami Dolphins logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Miami Dolphins 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Miami Dolphins logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Miami Dolphins Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Miami Dolphins mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Miami Dolphins Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Miami Dolphins front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Miami Dolphins Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Miami Dolphins logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Minnesota Vikings",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/min.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Minnesota Vikings 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Minnesota Vikings logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Minnesota Vikings 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Minnesota Vikings logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Minnesota Vikings 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Minnesota Vikings logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Minnesota Vikings Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Minnesota Vikings mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Minnesota Vikings Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Minnesota Vikings front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Minnesota Vikings Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Minnesota Vikings logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "New England Patriots",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/ne.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "New England Patriots 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered New England Patriots logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "New England Patriots 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered New England Patriots logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "New England Patriots 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the New England Patriots logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "New England Patriots Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered New England Patriots mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "New England Patriots Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered New England Patriots front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "New England Patriots Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered New England Patriots logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "New Orleans Saints",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/no.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "New Orleans Saints 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered New Orleans Saints logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "New Orleans Saints 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered New Orleans Saints logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "New Orleans Saints 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the New Orleans Saints logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "New Orleans Saints Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered New Orleans Saints mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "New Orleans Saints Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered New Orleans Saints front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "New Orleans Saints Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered New Orleans Saints logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "New York Giants",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/nyg.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "New York Giants 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered New York Giants logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "New York Giants 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered New York Giants logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "New York Giants 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the New York Giants logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "New York Giants Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered New York Giants mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "New York Giants Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered New York Giants front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "New York Giants Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered New York Giants logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "New York Jets",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/nyj.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "New York Jets 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered New York Jets logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "New York Jets 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered New York Jets logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "New York Jets 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the New York Jets logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "New York Jets Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered New York Jets mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "New York Jets Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered New York Jets front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "New York Jets Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered New York Jets logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Philadelphia Eagles",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/phi.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Philadelphia Eagles 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Philadelphia Eagles logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Philadelphia Eagles 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Philadelphia Eagles logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Philadelphia Eagles 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Philadelphia Eagles logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Philadelphia Eagles Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Philadelphia Eagles mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Philadelphia Eagles Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Philadelphia Eagles front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Philadelphia Eagles Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Philadelphia Eagles logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Pittsburgh Steelers",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/pit.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Pittsburgh Steelers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Pittsburgh Steelers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Pittsburgh Steelers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Pittsburgh Steelers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Pittsburgh Steelers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Pittsburgh Steelers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Pittsburgh Steelers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Pittsburgh Steelers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Pittsburgh Steelers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Pittsburgh Steelers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Pittsburgh Steelers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Pittsburgh Steelers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "San Francisco 49ers",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/sf.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "San Francisco 49ers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered San Francisco 49ers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "San Francisco 49ers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered San Francisco 49ers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "San Francisco 49ers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the San Francisco 49ers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "San Francisco 49ers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered San Francisco 49ers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "San Francisco 49ers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered San Francisco 49ers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "San Francisco 49ers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered San Francisco 49ers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Seattle Seahawks",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/sea.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Seattle Seahawks 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Seattle Seahawks logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Seattle Seahawks 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Seattle Seahawks logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Seattle Seahawks 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Seattle Seahawks logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Seattle Seahawks Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Seattle Seahawks mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Seattle Seahawks Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Seattle Seahawks front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Seattle Seahawks Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Seattle Seahawks logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Tampa Bay Buccaneers",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/tb.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Tampa Bay Buccaneers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Tampa Bay Buccaneers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Tampa Bay Buccaneers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Tampa Bay Buccaneers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Tampa Bay Buccaneers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Tampa Bay Buccaneers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Tampa Bay Buccaneers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Tampa Bay Buccaneers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Tampa Bay Buccaneers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Tampa Bay Buccaneers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Tampa Bay Buccaneers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Tampa Bay Buccaneers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Tennessee Titans",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/ten.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Tennessee Titans 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Tennessee Titans logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Tennessee Titans 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Tennessee Titans logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Tennessee Titans 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Tennessee Titans logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Tennessee Titans Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Tennessee Titans mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Tennessee Titans Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Tennessee Titans front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Tennessee Titans Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Tennessee Titans logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Washington Commanders",
      "league": "NFL",
      "logo": "https://a.espncdn.com/i/teamlogos/nfl/500/wsh.png",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Washington Commanders 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Washington Commanders logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Washington Commanders 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Washington Commanders logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Washington Commanders 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Washington Commanders logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Washington Commanders Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Washington Commanders mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Washington Commanders Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Washington Commanders front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Washington Commanders Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Washington Commanders logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    }
  ],
  "NHL": [
    {
      "team": "Anaheim Ducks",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/ANA_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Anaheim Ducks 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Anaheim Ducks logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Anaheim Ducks 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Anaheim Ducks logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Anaheim Ducks 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Anaheim Ducks logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Anaheim Ducks Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Anaheim Ducks mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Anaheim Ducks Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Anaheim Ducks front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Anaheim Ducks Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Anaheim Ducks logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Boston Bruins",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/BOS_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Boston Bruins 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Boston Bruins logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Boston Bruins 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Boston Bruins logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Boston Bruins 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Boston Bruins logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Boston Bruins Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Boston Bruins mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Boston Bruins Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Boston Bruins front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Boston Bruins Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Boston Bruins logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Buffalo Sabres",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/BUF_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Buffalo Sabres 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Buffalo Sabres logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Buffalo Sabres 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Buffalo Sabres logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Buffalo Sabres 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Buffalo Sabres logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Buffalo Sabres Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Buffalo Sabres mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Buffalo Sabres Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Buffalo Sabres front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Buffalo Sabres Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Buffalo Sabres logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Calgary Flames",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/CGY_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Calgary Flames 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Calgary Flames logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Calgary Flames 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Calgary Flames logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Calgary Flames 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Calgary Flames logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Calgary Flames Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Calgary Flames mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Calgary Flames Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Calgary Flames front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Calgary Flames Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Calgary Flames logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Carolina Hurricanes",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/CAR_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Carolina Hurricanes 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Carolina Hurricanes logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Carolina Hurricanes 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Carolina Hurricanes logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Carolina Hurricanes 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Carolina Hurricanes logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Carolina Hurricanes Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Carolina Hurricanes mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Carolina Hurricanes Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Carolina Hurricanes front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Carolina Hurricanes Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Carolina Hurricanes logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Chicago Blackhawks",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/CHI_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Chicago Blackhawks 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Chicago Blackhawks logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Chicago Blackhawks 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Chicago Blackhawks logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Chicago Blackhawks 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Chicago Blackhawks logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Chicago Blackhawks Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Chicago Blackhawks mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Chicago Blackhawks Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Chicago Blackhawks front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Chicago Blackhawks Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Chicago Blackhawks logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Colorado Avalanche",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/COL_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Colorado Avalanche 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Colorado Avalanche logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Colorado Avalanche 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Colorado Avalanche logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Colorado Avalanche 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Colorado Avalanche logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Colorado Avalanche Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Colorado Avalanche mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Colorado Avalanche Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Colorado Avalanche front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Colorado Avalanche Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Colorado Avalanche logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Columbus Blue Jackets",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/CBJ_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Columbus Blue Jackets 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Columbus Blue Jackets logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Columbus Blue Jackets 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Columbus Blue Jackets logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Columbus Blue Jackets 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Columbus Blue Jackets logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Columbus Blue Jackets Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Columbus Blue Jackets mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Columbus Blue Jackets Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Columbus Blue Jackets front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Columbus Blue Jackets Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Columbus Blue Jackets logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Dallas Stars",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/DAL_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Dallas Stars 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Dallas Stars logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Dallas Stars 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Dallas Stars logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Dallas Stars 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Dallas Stars logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Dallas Stars Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Dallas Stars mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Dallas Stars Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Dallas Stars front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Dallas Stars Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Dallas Stars logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Detroit Red Wings",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/DET_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Detroit Red Wings 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Detroit Red Wings logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Detroit Red Wings 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Detroit Red Wings logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Detroit Red Wings 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Detroit Red Wings logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Detroit Red Wings Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Detroit Red Wings mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Detroit Red Wings Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Detroit Red Wings front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Detroit Red Wings Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Detroit Red Wings logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Edmonton Oilers",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/EDM_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Edmonton Oilers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Edmonton Oilers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Edmonton Oilers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Edmonton Oilers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Edmonton Oilers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Edmonton Oilers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Edmonton Oilers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Edmonton Oilers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Edmonton Oilers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Edmonton Oilers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Edmonton Oilers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Edmonton Oilers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Florida Panthers",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/FLA_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Florida Panthers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Florida Panthers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Florida Panthers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Florida Panthers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Florida Panthers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Florida Panthers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Florida Panthers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Florida Panthers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Florida Panthers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Florida Panthers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Florida Panthers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Florida Panthers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Los Angeles Kings",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/LAK_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Los Angeles Kings 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Los Angeles Kings logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Los Angeles Kings 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Los Angeles Kings logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Los Angeles Kings 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Los Angeles Kings logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Los Angeles Kings Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Los Angeles Kings mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Los Angeles Kings Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Los Angeles Kings front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Los Angeles Kings Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Los Angeles Kings logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Minnesota Wild",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/MIN_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Minnesota Wild 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Minnesota Wild logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Minnesota Wild 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Minnesota Wild logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Minnesota Wild 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Minnesota Wild logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Minnesota Wild Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Minnesota Wild mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Minnesota Wild Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Minnesota Wild front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Minnesota Wild Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Minnesota Wild logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Montréal Canadiens",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/MTL_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Montréal Canadiens 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Montréal Canadiens logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Montréal Canadiens 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Montréal Canadiens logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Montréal Canadiens 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Montréal Canadiens logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Montréal Canadiens Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Montréal Canadiens mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Montréal Canadiens Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Montréal Canadiens front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Montréal Canadiens Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Montréal Canadiens logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Nashville Predators",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/NSH_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Nashville Predators 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Nashville Predators logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Nashville Predators 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Nashville Predators logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Nashville Predators 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Nashville Predators logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Nashville Predators Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Nashville Predators mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Nashville Predators Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Nashville Predators front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Nashville Predators Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Nashville Predators logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "New Jersey Devils",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/NJD_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "New Jersey Devils 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered New Jersey Devils logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "New Jersey Devils 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered New Jersey Devils logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "New Jersey Devils 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the New Jersey Devils logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "New Jersey Devils Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered New Jersey Devils mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "New Jersey Devils Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered New Jersey Devils front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "New Jersey Devils Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered New Jersey Devils logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "New York Islanders",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/NYI_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "New York Islanders 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered New York Islanders logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "New York Islanders 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered New York Islanders logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "New York Islanders 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the New York Islanders logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "New York Islanders Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered New York Islanders mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "New York Islanders Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered New York Islanders front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "New York Islanders Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered New York Islanders logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "New York Rangers",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/NYR_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "New York Rangers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered New York Rangers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "New York Rangers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered New York Rangers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "New York Rangers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the New York Rangers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "New York Rangers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered New York Rangers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "New York Rangers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered New York Rangers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "New York Rangers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered New York Rangers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Ottawa Senators",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/OTT_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Ottawa Senators 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Ottawa Senators logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Ottawa Senators 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Ottawa Senators logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Ottawa Senators 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Ottawa Senators logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Ottawa Senators Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Ottawa Senators mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Ottawa Senators Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Ottawa Senators front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Ottawa Senators Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Ottawa Senators logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Philadelphia Flyers",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/PHI_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Philadelphia Flyers 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Philadelphia Flyers logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Philadelphia Flyers 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Philadelphia Flyers logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Philadelphia Flyers 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Philadelphia Flyers logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Philadelphia Flyers Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Philadelphia Flyers mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Philadelphia Flyers Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Philadelphia Flyers front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Philadelphia Flyers Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Philadelphia Flyers logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Pittsburgh Penguins",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/PIT_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Pittsburgh Penguins 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Pittsburgh Penguins logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Pittsburgh Penguins 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Pittsburgh Penguins logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Pittsburgh Penguins 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Pittsburgh Penguins logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Pittsburgh Penguins Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Pittsburgh Penguins mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Pittsburgh Penguins Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Pittsburgh Penguins front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Pittsburgh Penguins Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Pittsburgh Penguins logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "San Jose Sharks",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/SJS_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "San Jose Sharks 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered San Jose Sharks logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "San Jose Sharks 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered San Jose Sharks logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "San Jose Sharks 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the San Jose Sharks logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "San Jose Sharks Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered San Jose Sharks mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "San Jose Sharks Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered San Jose Sharks front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "San Jose Sharks Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered San Jose Sharks logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Seattle Kraken",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/SEA_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Seattle Kraken 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Seattle Kraken logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Seattle Kraken 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Seattle Kraken logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Seattle Kraken 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Seattle Kraken logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Seattle Kraken Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Seattle Kraken mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Seattle Kraken Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Seattle Kraken front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Seattle Kraken Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Seattle Kraken logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "St. Louis Blues",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/STL_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "St. Louis Blues 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered St. Louis Blues logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "St. Louis Blues 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered St. Louis Blues logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "St. Louis Blues 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the St. Louis Blues logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "St. Louis Blues Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered St. Louis Blues mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "St. Louis Blues Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered St. Louis Blues front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "St. Louis Blues Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered St. Louis Blues logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Tampa Bay Lightning",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/TBL_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Tampa Bay Lightning 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Tampa Bay Lightning logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Tampa Bay Lightning 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Tampa Bay Lightning logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Tampa Bay Lightning 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Tampa Bay Lightning logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Tampa Bay Lightning Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Tampa Bay Lightning mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Tampa Bay Lightning Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Tampa Bay Lightning front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Tampa Bay Lightning Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Tampa Bay Lightning logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Toronto Maple Leafs",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/TOR_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Toronto Maple Leafs 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Toronto Maple Leafs logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Toronto Maple Leafs 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Toronto Maple Leafs logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Toronto Maple Leafs 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Toronto Maple Leafs logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Toronto Maple Leafs Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Toronto Maple Leafs mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Toronto Maple Leafs Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Toronto Maple Leafs front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Toronto Maple Leafs Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Toronto Maple Leafs logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Vancouver Canucks",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/VAN_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Vancouver Canucks 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Vancouver Canucks logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Vancouver Canucks 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Vancouver Canucks logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Vancouver Canucks 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Vancouver Canucks logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Vancouver Canucks Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Vancouver Canucks mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Vancouver Canucks Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Vancouver Canucks front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Vancouver Canucks Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Vancouver Canucks logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Vegas Golden Knights",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/VGK_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Vegas Golden Knights 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Vegas Golden Knights logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Vegas Golden Knights 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Vegas Golden Knights logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Vegas Golden Knights 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Vegas Golden Knights logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Vegas Golden Knights Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Vegas Golden Knights mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Vegas Golden Knights Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Vegas Golden Knights front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Vegas Golden Knights Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Vegas Golden Knights logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Washington Capitals",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/WSH_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Washington Capitals 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Washington Capitals logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Washington Capitals 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Washington Capitals logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Washington Capitals 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Washington Capitals logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Washington Capitals Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Washington Capitals mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Washington Capitals Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Washington Capitals front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Washington Capitals Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Washington Capitals logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    },
    {
      "team": "Winnipeg Jets",
      "league": "NHL",
      "logo": "https://assets.nhle.com/logos/nhl/svg/WPG_light.svg",
      "hats": [
        {
          "id": "team-basic-black",
          "title": "Winnipeg Jets 59FIFTY Team Basic Black Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Officially licensed New Era 59FIFTY fitted with an embroidered Winnipeg Jets logo on a structured 6-panel black crown and flat brim.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "team-color-fitted",
          "title": "Winnipeg Jets 59FIFTY Team Color Fitted Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Classic team-color crown with a raised embroidered Winnipeg Jets logo. Structured fit with a flat brim and green undervisor.",
          "style": "Fitted (59FIFTY)",
          "retailer": "New Era"
        },
        {
          "id": "9forty-snapback",
          "title": "Winnipeg Jets 9FORTY Adjustable Snapback",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Adjustable 9FORTY snapback featuring the Winnipeg Jets logo on a structured front panel with a flat brim and snap closure.",
          "style": "Snapback (9FORTY)",
          "retailer": "New Era"
        },
        {
          "id": "dad-hat",
          "title": "Winnipeg Jets Casual Classic Dad Hat",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Relaxed unstructured 9TWENTY dad hat with a soft pre-curved brim and an embroidered Winnipeg Jets mark on the front.",
          "style": "Dad Hat (9TWENTY)",
          "retailer": "New Era"
        },
        {
          "id": "low-profile-fitted",
          "title": "Winnipeg Jets Low Profile 59FIFTY Fitted",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Lower-crown 59FIFTY profile sits closer to the head with a clean embroidered Winnipeg Jets front logo.",
          "style": "Low Profile Fitted",
          "retailer": "New Era"
        },
        {
          "id": "two-tone-trucker",
          "title": "Winnipeg Jets Two-Tone Trucker",
          "price": "$45.00",
          "image": "",
          "bg": "#ffffff",
          "description": "Two-tone trucker with a structured front, mesh back panels, and an embroidered Winnipeg Jets logo. Snapback closure.",
          "style": "Trucker (9FORTY A-Frame)",
          "retailer": "New Era"
        }]
    }
  ]
};

export const teamSlug = (team: string) =>
  team.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const findTeam = (slug: string): TeamEntry | null => {
  for (const league of Object.keys(teamHats)) {
    const t = teamHats[league].find((e) => teamSlug(e.team) === slug);
    if (t) return t;
  }
  return null;
};
